export const no = {
	'welcome.title': 'Velkommen til Mainean',

	// Login page
	'login.app.name': 'MaintenanceHub',
	'login.app.subtitle': 'Vedlikeholdsoperasjoner Kontrollsenter',
	'login.welcome.title': 'Velkommen tilbake',
	'login.welcome.subtitle': 'Logg inn for å få tilgang til dashbordet',
	'login.button.azure': 'Logg inn med Microsoft Azure',
	'login.button.loading': 'Logger inn...',

	// System status
	'login.status.title': 'Systemstatus',
	'login.status.online': 'Tilkoblet',
	'login.status.sap.label': 'SAP Integrasjon',
	'login.status.sap.value': 'Tilkoblet',
	'login.status.aveva.label': 'AVEVA Tillatelser',
	'login.status.aveva.value': 'Aktiv',
	'login.status.twin.label': 'Digital Tvilling',
	'login.status.twin.value': 'Klar',

	// Footer
	'login.footer.copyright': '© 2024 MaintenanceHub. Sikre offshore vedlikeholdsoperasjoner.',
	'login.footer.privacy': 'Personvernerklæring',
	'login.footer.terms': 'Vilkår for bruk',
	'login.footer.support': 'Støtte',

	// User Profile page
	'profile.page.title': 'Brukerprofil',
	'profile.page.back': 'Gå tilbake',
	'profile.memberSince': 'Medlem siden',
	'profile.totalExperience': 'Total erfaring',
	'profile.yearsExperience': 'År',
	'profile.editProfile': 'Rediger profil',
	'profile.tasksCompleted': 'Fullførte oppgaver',
	'profile.onTimeCompletion': 'Rettidig fullføring',
	'profile.performanceScore': 'Ytelsesscore',
	'profile.companyWideRanking': 'Rangering i selskapet',
	'profile.qualityScore': 'Kvalitetsscore',
	'profile.performanceTrends': 'Ytelses\u00ADtrender',
	'profile.period.3m': 'Siste 3 måneder',
	'profile.period.6m': 'Siste 6 måneder',
	'profile.period.1y': 'Siste år',
	'profile.taskDistribution': 'Oppgavefordeling',
	'profile.achievementsBadges': 'Prestasjoner og merker',
	'profile.earned': 'opptjent',
	'profile.viewAllBadges': 'Se alle {count} merker',
	'profile.showLess': 'Vis færre',
	'profile.recentActivity': 'Nylig aktivitet',
	'profile.recentActivity.previous': 'Forrige',
	'profile.recentActivity.next': 'Neste',
	'profile.recentActivity.position': '{page} av {totalPages}',
	'profile.recentActivity.empty': 'Ingen nylig aktivitet',
	'profile.skillsExpertise': 'Ferdigheter og ekspertise',
	'profile.certifications': 'Sertifiseringer',
	'profile.validUntil': 'Gyldig til',
	'profile.expiresIn': 'Utløper om {days} dager',
	'profile.cert.status.valid': 'Gyldig',
	'profile.cert.status.expiring': 'Utløper snart',
	'profile.cert.status.expired': 'Utløpt',
	'profile.fullName': 'Fullt navn',
	'profile.email': 'E-post',
	'profile.phone': 'Telefon',
	'profile.location': 'Sted',
	'profile.readOnly': 'skrivebeskyttet',
	'profile.cancel': 'Avbryt',
	'profile.saving': 'Lagrer...',
	'profile.saveChanges': 'Lagre endringer',

	// Sidebar navigation
	'sidebar.nav.home': 'Hjem',
	'sidebar.nav.plantMaintenance': 'Anleggsvedlikehold',
	'sidebar.nav.plantNotifications': 'Anleggsvarsler',
	'sidebar.nav.campaign': 'Kampanje',
	'sidebar.nav.logistics': 'Logistikk',
	'sidebar.nav.reports': 'Rapporter',
	'sidebar.app.tagline': 'Enterprise',
	'sidebar.openMenu': 'Åpne meny',
	'sidebar.closeMenu': 'Lukk meny',

	// Work Orders Table
	'workOrdersTable.header.title': 'Alle arbeidsordrer',
	'workOrdersTable.header.subtitle': 'Filtrert etter rolle: Planlegger, Elektro',
	'workOrdersTable.search.placeholder': 'Søk etter AO, Tag eller beskrivelse...',
	'workOrdersTable.column.woNumber': 'AO-nummer',
	'workOrdersTable.column.description': 'Beskrivelse',
	'workOrdersTable.column.priority': 'Prioritet',
	'workOrdersTable.column.criticality': 'Kritikalitet',
	'workOrdersTable.column.installation': 'Installasjon',
	'workOrdersTable.column.status': 'Status',
	'workOrdersTable.column.assignedTo': 'Tildelt til',
	'workOrdersTable.assignee.unassigned': 'Ikke tildelt',
	'workOrdersTable.column.requiredEndDate': 'Krevd sluttdato',
	'workOrdersTable.empty': 'Ingen arbeidsordrer funnet',
	'workOrdersTable.error.loadFailed': 'Kunne ikke laste arbeidsordrer',

	// Work Orders Filter Modal
	'workOrdersTable.filter.title': 'Filtrer arbeidsordrer',
	'workOrdersTable.filter.priority.label': 'Prioritet',
	'workOrdersTable.filter.priority.placeholder': 'Alle prioriteter',
	'workOrdersTable.filter.status.label': 'Status',
	'workOrdersTable.filter.status.placeholder': 'Alle statuser',
	'workOrdersTable.filter.criticality.label': 'Kritikalitet',
	'workOrdersTable.filter.criticality.placeholder': 'Alle nivåer',
	'workOrdersTable.filter.installation.label': 'Installasjon',
	'workOrdersTable.filter.installation.placeholder': 'Alle installasjoner',
	'workOrdersTable.filter.assignedTo.label': 'Tildelt til',
	'workOrdersTable.filter.assignedTo.placeholder': 'Filtrer etter person...',
	'workOrdersTable.filter.sortBy.label': 'Sorter etter',
	'workOrdersTable.filter.sortBy.placeholder': 'Standardrekkefølge',
	'workOrdersTable.filter.sortBy.requiredEndDate': 'Krevd sluttdato',
	'workOrdersTable.filter.sortBy.priority': 'Prioritet',
	'workOrdersTable.filter.sortBy.status': 'Status',
	'workOrdersTable.filter.sortBy.criticality': 'Kritikalitet',
	'workOrdersTable.filter.sortDirection.label': 'Sorteringsretning',
	'workOrdersTable.filter.sortDirection.placeholder': 'Standard',
	'workOrdersTable.filter.sortDirection.asc': 'Stigende',
	'workOrdersTable.filter.sortDirection.desc': 'Synkende',
	'workOrdersTable.filter.reset': 'Tilbakestill alle',
	'workOrdersTable.filter.apply': 'Bruk filtre',
	'workOrdersTable.filter.discipline.label': 'Fagdisiplin',
	'workOrdersTable.filter.discipline.placeholder': 'Alle fagdisipliner',

	// Work Orders Discipline column
	'workOrders.table.discipline': 'Fagdisiplin',

	// Work Orders Bulk Actions
	'workOrders.bulk.selected': '{count} arbeidsordrer valgt',
	'workOrders.bulk.apply': 'Bruk',
	'workOrders.bulk.clear': 'Fjern valg',
	'workOrders.bulk.priority': 'Sett prioritet',
	'workOrders.bulk.status': 'Sett status',
	'workOrders.bulk.assignTo': 'Tildel til',
	'workOrders.bulk.successToast': '{count} arbeidsordrer oppdatert',
	'workOrders.bulk.status.noCommon': 'Ingen status er tilgjengelig for alle valgte arbeidsordrer',

	// Pagination
	'pagination.previous': 'Forrige',
	'pagination.next': 'Neste',
	'pagination.showing': 'Viser {count} av {total} arbeidsordrer',

	// Work Order Detail
	'workOrder.header.fallback': 'Arbeidsordre',
	'workOrder.notFound': 'Arbeidsordre ikke funnet',
	'workOrder.backToDashboard': 'Tilbake til dashbord',
	'workOrder.error.loadFailed': 'Kunne ikke laste arbeidsordredetaljer',

	// Work Order Status / Criticality
	'workOrder.status.open': 'Åpen',
	'workOrder.status.closed': 'Lukket',
	'workOrder.status.overdue': 'Forfalt',
	'workOrder.status.dueSoon': 'Forfaller snart',
	'workOrder.status.planned': 'Planlagt',
	'workOrder.status.scheduled': 'Tidsplanlagt',
	'workOrder.status.prepared': 'Forberedt',
	'workOrder.status.executed': 'Utført',
	'workOrder.criticality.low': 'Lav',
	'workOrder.criticality.medium': 'Middels',
	'workOrder.criticality.critical': 'Kritisk',

	// Priority Badge
	'priorityBadge.label': 'PRIORITET {priority}',

	// Task Description
	'taskDescription.title': 'Oppgavebeskrivelse',

	// Subtasks
	'subtasks.title': 'Deloppgaver',
	'subtasks.progress': '{completed} av {total} fullført',
	'subtasks.planned': 'Planlagt: {date}',
	'subtasks.completed': 'Fullført {date}',

	// Assigned Personnel
	'assignedPersonnel.title': 'Tildelt personell',
	'assignedPersonnel.add': 'Legg til',
	'assignedPersonnel.unknown': 'Ukjent',

	// Spare Parts
	'spareParts.title': 'Reservedeler',
	'spareParts.status.available': 'Tilgjengelig',
	'spareParts.status.inTransit': 'Under transport',
	'spareParts.status.missing': 'Mangler',
	'spareParts.status.reserved': 'Reservert',
	'spareParts.status.unknown': 'Ukjent',
	'spareParts.partInfo': 'D/N: {partNumber} • Ant: {quantity}',
	'spareParts.unknownPart': 'Ukjent del',

	// Related Work Orders
	'relatedWorkOrders.title': 'Relaterte arbeidsordrer for samme system',
	'relatedWorkOrders.available': '{count} tilgjengelige',
	'relatedWorkOrders.description': 'Kombiner vedlikeholdsoppgaver for å optimalisere tid og ressurser',
	'relatedWorkOrders.collapse': 'Skjul',
	'relatedWorkOrders.expandAll': 'Utvid alle',
	'relatedWorkOrders.efficiency.title': 'Effektivitetsanbefaling',
	'relatedWorkOrders.efficiency.description':
		'Kombinering av disse arbeidsordrene kan spare omtrent {hours} timer nedetid og redusere logistikkostnader med {amount}',
	'relatedWorkOrders.card.due': 'Forfaller: {date}',
	'relatedWorkOrders.card.est': 'Est: {hours} timer',
	'relatedWorkOrders.card.technicians': '{count, plural, one {# tekniker} other {# teknikere}}',
	'relatedWorkOrders.card.addToBatch': 'Legg til i batch',
	'relatedWorkOrders.card.viewDetails': 'Se detaljer',

	// Logs & Comments
	'logsAndComments.title': 'Logger og kommentarer',
	'logsAndComments.addComment': 'Legg til kommentar',
	'logsAndComments.time.unknown': 'Ukjent tidspunkt',
	'logsAndComments.time.justNow': 'Akkurat nå',
	'logsAndComments.time.hoursAgo': '{hours, plural, one {# time siden} other {# timer siden}}',
	'logsAndComments.time.daysAgo': '{days, plural, one {# dag siden} other {# dager siden}}',
	'logsAndComments.comment': 'Kommentar',
	'logsAndComments.dialog.title': 'Legg til kommentar',
	'logsAndComments.dialog.actionLabel': 'Handlingstype',
	'logsAndComments.dialog.actionPlaceholder': 'Velg handlingstype',
	'logsAndComments.dialog.action.comment': 'Kommentar',
	'logsAndComments.dialog.action.reject': 'Avvis',
	'logsAndComments.dialog.action.requestMoreInfo': 'Be om mer informasjon',
	'logsAndComments.dialog.descriptionLabel': 'Beskrivelse',
	'logsAndComments.dialog.descriptionPlaceholder': 'Skriv din kommentar...',
	'logsAndComments.dialog.cancel': 'Avbryt',
	'logsAndComments.dialog.submit': 'Send inn',
	'logsAndComments.dialog.submitting': 'Sender inn...',
	'logsAndComments.noComments': 'Ingen kommentarer ennå',

	// Layout Documents
	'layoutDocuments.title': 'Layoutdokumenter',
	'layoutDocuments.revision': 'Rev {revision}',
	'layoutDocuments.open': 'Åpne',

	// ICC Plan Viewer
	'iccPlanViewer.title': 'ICC-planvisning',
	'iccPlanViewer.fullView': 'Full visning',
	'iccPlanViewer.certificateLabel': 'Isolasjonssertifikatplan',

	// Other Attachments
	'otherAttachments.title': 'Andre vedlegg',
	'otherAttachments.uploadNew': 'Last opp ny',

	// Home Page
	'homePage.title': 'Dashbordoversikt',
	'homePage.subtitle': 'Kontrollsenter for vedlikeholdsoperasjoner',

	// Critical Tasks
	'criticalTasks.title': 'Kritiske oppgaver',
	'criticalTasks.subtitle': 'Neste 7 dager • Høy prioritet',
	'criticalTasks.error.loadFailed': 'Kunne ikke laste kritiske oppgaver',
	'criticalTasks.empty': 'Ingen kritiske oppgaver for øyeblikket',
	'criticalTasks.total': 'Totalt',

	// User Workload
	'userWorkload.title': 'Min arbeidsbelastning',
	'userWorkload.error.loadFailed': 'Kunne ikke laste arbeidsbelastning',
	'userWorkload.status.planned': 'Planlagt',
	'userWorkload.status.workingOn': 'Jobber med',
	'userWorkload.status.toBePlanned': 'Skal planlegges',
	'userWorkload.status.completed': 'Fullført',
	'userWorkload.status.inProgress': 'Pågår',

	// Reports Page
	'reportsPage.title': 'Vedlikeholdsanalyse',
	'reportsPage.subtitle': 'Rapporter for {start} – {end}',

	// Date Range Picker
	'dateRangePicker.last7Days': 'Siste 7 dager',
	'dateRangePicker.last30Days': 'Siste 30 dager',
	'dateRangePicker.last90Days': 'Siste 90 dager',
	'dateRangePicker.last12Months': 'Siste 12 måneder',

	// Analytics Summary
	'analyticsSummary.totalWorkOrders': 'Totalt arbeidsordrer',
	'analyticsSummary.completionRate': 'Fullføringsgrad',
	'analyticsSummary.avgResponseTime': 'Gjennomsnittlig responstid',
	'analyticsSummary.overdue': 'Forfalt',

	// Completion Status Chart
	'completionStatus.title': 'Fullføringsstatus',
	'completionStatus.subtitle': 'Statusfordeling for arbeidsordrer',

	// Equipment Downtime Chart
	'equipmentDowntime.title': 'Analyse av utstyrsstans',
	'equipmentDowntime.week': 'Uke {n}',
	'equipmentDowntime.planned': 'Planlagt',
	'equipmentDowntime.unplanned': 'Uplanlagt',

	// Monthly Performance Chart
	'monthlyPerformance.title': 'Månedlige ytelsesmålinger',
	'monthlyPerformance.onTrack': 'På sporet',
	'monthlyPerformance.completionRate': 'Fullføringsgrad',

	// Performance by Installation Chart
	'performanceByInstallation.title': 'Ytelse etter installasjon',
	'performanceByInstallation.all': 'Alle',
	'performanceByInstallation.completed': 'Fullført',
	'performanceByInstallation.inProgress': 'Pågår',
	'performanceByInstallation.overdue': 'Forfalt',

	// Priority Breakdown
	'priorityBreakdown.title': 'Prioritetsfordeling',
	'priorityBreakdown.subtitle': 'Arbeidsordrer etter prioritetsnivå',
	'priorityBreakdown.empty': 'Ingen data tilgjengelig',

	// Work Order Trends Chart
	'workOrderTrends.title': 'Arbeidsordretrender',

	// Discipline Chart
	'disciplineChart.title': 'Arbeidsordrer etter fagdisiplin',
	'disciplineChart.subtitle': 'Fordeling etter vedlikeholdsgren',
	'disciplineChart.completed': 'Fullført',
	'disciplineChart.pending': 'Ventende',

	// Error / Loading states
	'errorState.message': 'Noe gikk galt',
	'errorState.retry': 'Prøv igjen',

	// Settings page
	'settings.page.title': 'Innstillinger og administrasjon',
	'settings.page.subtitle': 'Systemkonfigurasjon og brukeradministrasjon',
	'sidebar.nav.settings': 'Innstillinger',

	// User Roles & Permissions widget
	'settings.userRoles.title': 'Brukerroller og tillatelser',
	'settings.userRoles.editUser': 'Rediger bruker',
	'settings.userRoles.viewAll': 'Vis alle brukere ({count})',
	'settings.userRoles.role.administrator': 'Administrator',
	'settings.userRoles.role.notAdmin': 'Standardbruker',
	'settings.userRoles.search.placeholder': 'Søk etter navn eller e-post',
	'settings.userRoles.column.admin': 'Admin',
	'settings.userRoles.column.name': 'Navn',
	'settings.userRoles.column.email': 'E-post',
	'settings.userRoles.empty': 'Ingen brukere funnet',
	'settings.userRoles.pagination.previous': 'Forrige',
	'settings.userRoles.pagination.next': 'Neste',
	'settings.userRoles.pagination.position': '{page} av {totalPages}',

	// Edit User modal
	'settings.editUser.title': 'Rediger bruker',
	'settings.editUser.name': 'Navn',
	'settings.editUser.email': 'E-post',
	'settings.editUser.admin': 'Administrator',
	'settings.editUser.installations': 'Installasjoner',
	'settings.editUser.installation': 'Installasjon',
	'settings.editUser.disciplines': 'Fag',
	'settings.editUser.disciplines.placeholder.none': 'Ingen',
	'settings.editUser.disciplines.placeholder.all': 'Alle fag',
	'settings.editUser.disciplines.selectAll': 'Velg alle',
	'settings.editUser.disciplines.clear': 'Fjern',
	'settings.editUser.disciplines.done': 'Ferdig',
	'settings.editUser.disciplines.close': 'Lukk',
	'settings.editUser.disciplines.empty': 'Ingen fag tilgjengelig',
	'settings.editUser.disciplines.searchPlaceholder': 'Søk fag',
	'settings.editUser.disciplines.triggerAria': 'Rediger fag for {installation}',
	'settings.editUser.save': 'Lagre',
	'settings.editUser.cancel': 'Avbryt',
	'settings.editUser.saving': 'Lagrer…',
	'settings.editUser.loadError': 'Kunne ikke laste brukerdetaljer. Prøv igjen.',

	// Data Import
	'settings.importData.title': 'Dataimport',
	'settings.importData.subtitle': 'Last opp en Excel-fil for å importere data til en installasjon',
	'settings.importData.installationLabel': 'Installasjon',
	'settings.importData.installationPlaceholder': 'Velg en installasjon',
	'settings.importData.dropzone.idle': 'Dra og slipp en fil her, eller klikk for å bla gjennom',
	'settings.importData.dropzone.hint': 'XLSX eller XLS, maks 1 fil',
	'settings.importData.remove': 'Fjern fil',
	'settings.importData.submit': 'Importer',
	'settings.importData.submitting': 'Importerer…',
	'settings.importData.success': 'Data ble importert.',
	'settings.importData.error': 'Kunne ikke importere data. Prøv igjen.',
	'settings.importData.errors.invalidType': 'Kun .xlsx- eller .xls-filer er tillatt.',
	'settings.importData.errors.tooManyFiles': 'Du kan kun laste opp én fil om gangen.',

	// Common
	'common.loading': 'Laster…',
};
